import { isRegExp } from "lodash";
import { Util } from "../../../common/common";
import { CartCookie } from "./components/CartCookie";
import { CartDatabase } from "./components/CartDatabase";
import { CartItems,CartItem } from "./components/DataType";
declare var isUserLogin:boolean;
export class Cart{
    private totalPrice=0;
    private autoId=0;
    private items:CartItems;
    private cartRepository:CartCookie | CartDatabase;
    constructor(){
        this.refresh();
        
    }

    refresh(){
        let cartCookie=new CartCookie();
        let cartCookieItems=cartCookie.getItems(),cartDatabaseItems:CartItems=[];
        if(isUserLogin){
            let cartDatabase=new CartDatabase(),_this=this;
            this.cartRepository=cartDatabase;
            cartDatabaseItems=cartDatabase.getItems();
            this.items=_this.mergeItems(cartCookieItems,cartDatabaseItems);
            this.autoId=_this.initAutoId();
            cartCookie.empty();
        }else{
            this.cartRepository=cartCookie;
            this.items=cartCookieItems;
            this.autoId=this.initAutoId()
        }
        this.onItemsChange(this);
    }

    private initAutoId(){
        let autoId=0;
        this.items.map(item=>{
            if(typeof(item.autoId)=="undefined"){
                autoId++;
                item.autoId=autoId;
            }else if(autoId<item.autoId){
                autoId=item.autoId
            }
        })
        return autoId;
    }
    /**
     * cookie和数据库合并
     * @param cartCookieItems 
     * @param cartDatabaseItems 
     * @returns 
     */
    private mergeItems(cartCookieItems:CartItems,cartDatabaseItems:CartItems){
        /*let oCartCookieItems={},oCartDatabaseItems={};
        let _this=this;

        $.each(cartDatabaseItems,function(i,item){
            oCartDatabaseItems[item.goods_type+"_"+item.goods_id+"_"+item.sku]=item;
        })

        $.each(cartCookieItems,function(i,item){
            let k=item.goods_type+"_"+item.goods_id+"_"+item.sku;
            oCartCookieItems[k]=item;
            if(!(k in oCartDatabaseItems) && isUserLogin){
                _this.cartRepository.addItem(item,null);
            }
        })
        let oitems= $.extend(true,{},oCartCookieItems,oCartDatabaseItems),items:any=[];
        $.each(oitems,function(k,item){
            items.push(item);
        })*/
        let items=$.extend([],cartCookieItems,cartDatabaseItems);
        return items;
    }

    getItems(){
        return this.items;
    }
    
    addItem(item:CartItem){
        let _this=this,skuExist=false,ret;
        
       /* $.each(this.items,function(index,itm:CartItem){
            if(itm.sku==item.sku && itm.goods_id==item.goods_id && itm.goods_type==item.goods_type){
                
                itm.num=1;
                let keys=['title','img','org_price','price','sku_text','query_log_id','user_files','address','remark'];
                $.each(keys,function(i,k){
                    itm[k]=item[k];
                })
                ret=_this.repoUpdateItem(itm);
                skuExist=true;
                return false;
            }
        })*/
        if(!skuExist){
            item.autoId=++this.autoId;
            this.items.push(item);
            ret= this.cartRepository.addItem(item,this.items);
        }
        this.onItemsChange(this);
        return ret;
        
    }
   /* modifyNum(autoId,num){
        let itemId;
        $.each(this.items,function(i,itm:CartItem){
            if(itm.autoId==autoId){
                itemId=itm.id;
                itm.num=num;
                return false;
            }
        })
        this.onItemsChange(this);
        return  this.cartRepository.modifyNum(itemId,num,this.items)
    }*/
    repoUpdateItem(item:CartItem){
        this.onItemsChange(this);
        return  this.cartRepository.updateItem(item,this.items)
    }
   /* incOrDec(autoId,incOrDec="inc"){
        let num,itemId;
        $.each(this.items,function(i,itm:CartItem){
            if(itm.autoId==autoId){
                num=itm.num;
                itemId=itm.id;
                if(incOrDec=="inc"){
                    num++;
                }else if(itm.num>0){
                    num--;
                }
                itm.num=num;
                return false;
            }
        })
        this.onItemsChange(this);
        return  this.cartRepository.modifyNum(itemId,num,this.items)
    }*/
    removeItems(autoIds:Array<string|number>){
        let itemsNew=[],itemIds=[];
        this.items.map(item=>{
            if(!Util.inArray(item.autoId,autoIds)){
                itemsNew.push(item);
            }else{
                itemIds.push(item.id);
            }
        })
        this.items=itemsNew;
        this.onItemsChange(this);
        return this.cartRepository.removeItems(itemIds,this.items)
    }
    empty(){
        this.items=[];
        this.onItemsChange(this);
        return this.cartRepository.empty()
    }
    getTotalMemberPrice(){
        let totalMemberPrice=0;
        this.items.map(item=>{
            if(item.checked==1){
                totalMemberPrice+=item.member_price;
            }
            
        })
        return totalMemberPrice;
    }   
    getTotalNum(){
        return this.items.length;
    }
    submitOrder(){
        console.log(this.items);
    }   
    
    
    handleCheck(autoId){
        let _this=this, mode;
        this.items.every(item=>{
            if(autoId==item.autoId){
                if(item.checked==1){
                    item.checked=0;
                    mode="uncheck";
                }else{
                    item.checked=1;
                    mode="check";
                }
                _this.cartRepository.checkItem(item.id,mode,this.items)
                return false;
            }else{
                return true;
            }
        })
        
    } 
    handleCheckAll(checkAll=0){
        this.items.map(item=>{
            item.checked=checkAll;
        })
        let mode=checkAll==0?"uncheckall":"checkall";
        this.cartRepository.checkItem(null,mode,this.items)
    }
    
    onItemsChange(t){
       
    }
}

export var cart=new Cart();